export default class Roles {

  public static Admin = 'ADMIN'
  public static Tenant = 'TENANT'
  public static Driver = 'DRIVER'
}
